import React from 'react'
import { withStyles, TextField, Button, Select, MenuItem, FormControl, InputLabel, Typography } from '@material-ui/core';
import { addUser } from '../../Helpers/UserHelpers';

const styles = theme => ({
    field: {
        marginBottom: theme.spacing(3)
    }
})

class AddUser extends React.Component {
    state = {
        userData: {
            displayName: '',
            email: '',
            accessLevel: 'author',
            password: '',
        },
        done: false,
        error: null,
        locked: false
    }

    handleChange = (e) => {
        let userData = this.state.userData;
        if (e.target.name === 'accessLevel') {
            userData[e.target.name] = e.target.value;
        } else {
            userData[e.target.id] = e.target.value;
        }
        this.setState({ userData })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ error: null, locked: true });
        addUser(this.state.userData)
            .then(() => this.setState({ done: true }))
            .catch(error => this.setState({ error, locked: false }));
    }

    renderForm = () => {        
        const { classes } = this.props;
        return (
            <form onSubmit={this.handleSubmit}>
                <Typography color="error">{this.state.error ? this.state.error : ''}</Typography>
                <TextField
                    id="displayName"
                    value={this.state.userData.displayName}
                    fullWidth
                    required
                    placeholder="Display name"
                    onChange={this.handleChange}
                    className={classes.field} />
                <TextField
                    id="email"
                    value={this.state.userData.email}
                    type="email"
                    fullWidth
                    required
                    placeholder="Email"
                    onChange={this.handleChange}
                    className={classes.field} />
                <TextField
                    id="password"
                    value={this.state.userData.password}
                    type="password"
                    fullWidth
                    required
                    placeholder="Password"
                    onChange={this.handleChange}
                    className={classes.field} />
                <FormControl className={classes.field} fullWidth>
                    <InputLabel id="accessLevel-label">Access Level</InputLabel>
                    <Select
                        labelId="accessLevel-label"
                        id="accessLevel"
                        name="accessLevel"
                        value={this.state.userData.accessLevel}
                        placeholder="Access Level"
                        fullWidth
                        required
                        onChange={this.handleChange}>
                            <MenuItem value="admin">Admin</MenuItem>
                            <MenuItem value="author">Author</MenuItem>
                    </Select>
                </FormControl>
                <Button disabled={this.state.locked} variant="contained" type="submit" color="primary">Add</Button>
            </form>
        )
    };

    renderSuccess = () => (
        <Typography color="primary">User added successfully</Typography>
    )

    render() {
        return(
            <div>
                {this.state.done ? this.renderSuccess() : this.renderForm()}
            </div>
        )
    }
}

export default withStyles(styles)(AddUser);